<template>
    <div>
        <v-row>
            <v-col cols="9">
                <h1 class="headline font-weight-light mb-3">
                    <span class="link-a cur-p" @click="back()">
                        Return Document</span
                    >
                    / Print
                </h1>
            </v-col>
            <v-col cols="3" class="text-right">
                <v-btn rounded small @click="print2()">
                    <v-icon class="mr-1" dark small>mdi-printer</v-icon>
                    Print</v-btn
                >
            </v-col>
        </v-row>
        <div id="printDiv">
            <!-- ที่เขียน inline เพราะ css ไม่ยอมทำงานตอนปริ้น -->
            <div style="margin: 0px !important;">
                <v-row>
                    <v-col cols="6">
                        <b>วันที่จัดส่ง {{ data_print.created_date }}</b>
                    </v-col>
                    <v-col cols="6" class="text-right"
                        ><b>เลขที่เอกสาร {{ doc_no }}</b></v-col
                    >
                </v-row>

                <v-row style="background-color: rgb(221, 221, 221);">
                    <v-col cols="3"></v-col>
                    <v-col cols="6" class="text-center mt-1 mb-1">
                        <b>ใบนำส่งเอกสาร</b>
                    </v-col>
                    <v-col cols="3" class="text-right  mt-1 mb-1">
                        <span style="color:#00a9ff; font-weight: bold;"
                            >Hybrid Pro</span
                        >
                    </v-col>
                </v-row>

                <br />

                <v-row>
                    <v-col cols="6"
                        ><b>ชื่อศูนย์บริการ : </b
                        >{{ data_print.branch_name }}</v-col
                    >
                    <v-col cols="6"
                        ><b>สถานที่ส่ง : </b>
                        {{ data_print.doc_address }}</v-col
                    >
                </v-row>

                <v-row>
                    <v-col cols="6"
                        ><b>ชื่อ : </b
                        >{{
                            data_print.created_name +
                                " (" +
                                data_print.created_by +
                                ")"
                        }}</v-col
                    >
                    <v-col cols="6"
                        ><b>ผู้ติดต่อ : </b>{{ data_print.doc_admin }}</v-col
                    >
                </v-row>

                <v-row>
                    <v-col cols="6"
                        ><b>หมายเลขโทรศัพท์ : </b
                        >{{ data_print.created_tel }}</v-col
                    >
                    <v-col cols="6"
                        ><b>หมายเลขโทรศัพท์ : </b>
                        {{ data_print.doc_tel }}</v-col
                    >
                </v-row>

                <v-row class="mt-4">
                    <v-col cols="12">
                        <table border="1" width="100%">
                            <thead>
                                <tr
                                    class="text-center"
                                    style="background-color: rgb(221, 221, 221);"
                                >
                                    <th>No.</th>
                                    <th>Project</th>
                                    <th>Case ID</th>
                                    <th>Product Serial</th>
                                    <th>Onsite Date</th>
                                    <th>CSO No.</th>
                                    <th>Site</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(row,
                                    index) in data_print.case_detail"
                                    :key="index"
                                >
                                    <td class="text-center">
                                        {{ index + 1 }}.
                                    </td>
                                    <td>
                                        <span style="margin-left:5px;">{{
                                            row.project_name
                                        }}</span>
                                    </td>
                                    <td class="text-center">
                                        {{ row.case_id + "-" + row.subcase }}
                                    </td>
                                    <td class="text-center">
                                        {{ row.product_serial }}
                                    </td>
                                    <td class="text-center">
                                        {{ row.onsite_at }}
                                    </td>
                                    <td class="text-center">
                                        {{ row.csono }}
                                    </td>
                                    <td>
                                        <span style="margin-left:5px;">{{
                                            row.site_name
                                        }}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </v-col>
                </v-row>
                <v-row class="mt-4">
                    <v-col cols="6" class="text-left">
                        <b>ลงชื่อ</b>
                        ___________________________________ผู้ส่งเอกสาร
                    </v-col>
                    <v-col cols="6" class="text-right">
                        <b>ลงชื่อ</b>
                        ___________________________________ผู้รับเอกสาร
                    </v-col>
                </v-row>
                <v-row class="mt-4">
                    <v-col cols="6" class="text-left">
                        <b>วันที่</b>
                        _________________________________________________
                    </v-col>
                    <v-col cols="6" class="text-right">
                        <b>วันที่</b>
                        _________________________________________________
                    </v-col>
                </v-row>
            </div>
        </div>
        <div id="snackbar" class="d-print-none">
            <v-snackbar v-model="snackbar" color="success" right>
                {{ text }}
            </v-snackbar>
        </div>
    </div>
</template>
<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"

const url = `${process.env.VUE_APP_ROOT_API}/api/`
export default {
    mounted() {
        this.doc_no = this.$route.params.doc_no
        this.get_data()

        if (this.$route.params.status === "save") {
            this.print()
        }
    },
    computed: {
        ...mapState(["isLoading"]),
        ...mapState(["snackbar"]),
    },
    methods: {
        ...mapMutations(["mutateIsLoading"]),
        ...mapMutations(["mutatesnackbar"]),
        async get_data() {
            await axios
                .get(url + "document/print/" + this.doc_no)
                .then((response) => {
                    this.data_print = response.data
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        print() {
            this.mutateIsLoading()
            setTimeout(() => {
                this.mutatesnackbar()
                this.mutateIsLoading()
            }, 1000)

            setTimeout(() => {
                this.mutatesnackbar()
                // this.$htmlToPaper("printDiv")
            }, 3000)
        },
        print2() {
            this.mutateIsLoading()
            setTimeout(() => {
                this.mutateIsLoading()
                this.$htmlToPaper("printDiv")
            }, 2000)
        },
        // print3() {
        //     // คิดยังไม่ออกตอนนี้ เลยทำปริ้น 3 ขึ่นมาก่อน
        //     // this.mutateIsLoading()

        back() {
            this.$router.push("/Onsite/Main/Return-Document")
        },
    },
    data() {
        return {
            data_print: [],
            text: "Success, Your work has been saved",
            doc_no: 0,
        }
    },
}
</script>
